import React from 'react'
import Sidebar from '../components/mainpage/subcomponent/Sidebar'
import '../components/styles/dashboard.css'
import Dealpage from '../components/mainpage/subcomponent/dealpage'

const MainDealPage = () => {
    return (
        <div>
            <Sidebar />
            <div className='container-fluid'>
                <Dealpage />
            </div>
        </div>
    )
}

export default MainDealPage